import React from 'react';

/** Filtro "Fecha Inicio" / "Fecha Fin" de los listados de V1 (default: hoy-30 -> hoy). */
export default function FiltroFechas({ inicio, fin, onInicio, onFin }) {
  return (
    <div className="flex flex-wrap items-end gap-3">
      <div>
        <label className="label">Fecha Inicio</label>
        <input type="date" value={inicio} onChange={(e) => onInicio(e.target.value)} className="input-base" />
      </div>
      <div>
        <label className="label">Fecha Fin</label>
        <input type="date" value={fin} onChange={(e) => onFin(e.target.value)} className="input-base" />
      </div>
    </div>
  );
}
